export default "__VITE_ASSET__pakyy3be__"